const SEGMENT = /[^.[\]]+/g;
const MAX_DEPTH = 12;

// Widgets are addressed by their builder key (`field.<key>...`) rather than by
// position, so that inserting or moving a field does not repoint every
// translation. Resolving such a path means finding the widget in the tree.
function findByKey(node, key, depth = 0) {
    if (node == null || typeof node !== 'object' || depth > MAX_DEPTH) return null;
    if (Array.isArray(node)) {
        for (const item of node) {
            const found = findByKey(item, key, depth + 1);
            if (found) return found;
        }
        return null;
    }
    if (node.key === key) return node;
    for (const child of [node.schema, node.list, node.columns]) {
        const found = findByKey(child, key, depth + 1);
        if (found) return found;
    }
    return null;
}

// Choices carry no key, so they are addressed by their stable `value`; a purely
// numeric segment is still an array index (legacy paths and duplicate values).
function step(node, segment) {
    if (node == null) return null;
    if (Array.isArray(node)) {
        if (/^\d+$/.test(segment)) return node[Number(segment)];
        return node.find((item) => item && item.value === segment) ?? null;
    }
    return node[segment];
}

// Mutates its argument — clone first if the source is shared (Vuex, a cache)
export function applyTranslations(document, pathValueMap) {
    for (const [path, value] of Object.entries(pathValueMap)) {
        const segments = path.match(SEGMENT);
        if (!segments || !segments.length) continue;

        let node = document;
        let rest = segments;

        if (segments[0] === 'field' && segments.length > 2) {
            const widget = findByKey(document, segments[1]);
            if (!widget) continue;
            node = widget;
            rest = segments.slice(2);
        }

        let ok = true;
        for (let i = 0; i < rest.length - 1; i++) {
            node = step(node, rest[i]);
            if (node == null) { ok = false; break; }
        }
        if (ok && node != null) node[rest[rest.length - 1]] = value;
    }
    return document;
}
